<template>
    <landlords-find
        :params="{
            landlord: $route.params.landlord
        }"
        :include="[
            'alerts(paginate:1,3)',
            'tasks(paginate:1,5)',
        ]"
        v-slot="{
            data: landlord,
            error,
            has_loaded,
            find
        }"
    >
        <div>
            <template v-if="!has_loaded || error">
                <base-loading
                    :error="error"
                    :retry="find"
                    class="py-6"
                />

                <error-modal
                    v-if="error"
                    :error="error"
                />
            </template>

            <template v-else>
                <base-hint name="landlords-overview-index">
                    <template slot="heading">
                        Welcome to Rentora, {{ landlord.first_name }}!
                    </template>

                    <p class="mb-3">
                        We’ve added hints like this one throughout your dashboard to
                        help you settle in. In no time you'll be listing your properties,
                        managing tenancies, collecting rent and more.
                    </p>

                    <p class="mb-3">
                        You’re currently on your dashboard overview page. Would you like us to show you around?
                    </p>

                    <button
                        class="w-full btn btn-sm btn-grey-darker md:w-auto"
                        @click.prevent="introjs"
                    >
                        What's on this page?
                    </button>
                </base-hint>

                <alerts-card
                    :data="landlord.alerts.data"
                    :meta="landlord.alerts.meta"
                    class="mb-6"
                />

                <events-calendar
                    class="mb-6 id-events-calendar-card"
                />

                <tasks-get
                    :page="1"
                    :per-page="5"
                    v-slot="{
                        data: tasks,
                        meta,
                        is_loading,
                        get
                    }"
                >
                    <tasks-card
                        :data="tasks || []"
                        :meta="meta || { has_loaded: false }"
                        :can-new="true"
                        :new-to="{
                            name: $router.fix('dashboard.*.tasks.create')
                        }"
                        :is-loading="is_loading"
                        class="mb-6 id-tasks-card"
                        @success="get"
                    />
                </tasks-get>
            </template>
        </div>
    </landlords-find>
</template>

<script>
    import _ from 'lodash'
    import scroll from '../../../../support/scroll'
    import AlertsCard from '../../../../components/alerts-card'
    import EventsCalendar from '../../_/overview/index/events-calendar'
    import LandlordsFind from '../../../../components/landlords-find'
    import TasksCard from '../../../../components/tasks-card'
    import TasksGet from '../../../../components/tasks-get'

    export default {
        components: {
            AlertsCard,
            EventsCalendar,
            LandlordsFind,
            TasksCard,
            TasksGet
        },
        beforeRouteLeave (to, from, next) {
            this.$introjs.exit()

            next()
        },
        created () {
            this.$eventBus.$on('the-layout-dashboard:is_sidebar_open', () => {
                this.$introjs.exit()
            })
        },
        methods: {
            introjs () {
                this.$introjs.start([
                    {
                        intro: '<p>Your calendar will show you upcoming events, for example, rent due dates and expiring gas certificates.</p>',
                        element: '.id-events-calendar-card'
                    },
                    {
                        intro:
                            '<p>Tasks will keep you on track with what to do next.</p>' +
                            '<p class="text-sm">p.s. You can click on tasks.</p>',
                        element: '.id-tasks-card'
                    },
                    {
                        intro:
                            '<p class="mb-3">Take a look around the rest of your dashboard.</p>' +
                            '<p class="mb-3">We recommend starting with creating your first property.</p>' +
                            '<p>Tap this icon to open the menu, and then “Properties” to get started.</p>',
                        element: '.id-sidebar-menu',
                        position: 'bottom',
                        when: () => {
                            return !this.$screen.is('lg')
                        }
                    },
                    {
                        intro:
                            '<p class="mb-3">Take a look around the rest of your dashboard.</p>' +
                            '<p class="mb-3">We recommend starting with creating your first property.</p>' +
                            '<p>Click “Properties” to get started.</p>',
                        element: '.id-sidebar-links',
                        position: 'right',
                        highlightClass: 'bg-grey-darker!',
                        when: () => {
                            return this.$screen.is('lg')
                        }
                    }
                ])
                    .onafterchange((element, introjs) => {
                        if (_.chain(element.className).split(' ').includes('id-sidebar-menu').value()) {
                            scroll.toTop()

                            setTimeout(() => {
                                introjs.refresh()
                            }, 0)
                        }
                    })
            }
        }
    }
</script>
